import React, { useEffect, useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { Search, Plus, Pencil, Trash2, X, Save } from 'lucide-react';

const SEOManager = () => {
  const { api } = useAuth();
  const [pages, setPages] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState({ path: '', title: '', description: '', keywords: '', og_image: '' });

  const load = () => api.get('/admin/seo').then(r => setPages(r.data)).catch(console.error);
  useEffect(() => { load(); }, []);

  const resetForm = () => { setForm({ path: '', title: '', description: '', keywords: '', og_image: '' }); setEditing(null); setShowForm(false); };

  const handleSave = async (e) => {
    e.preventDefault();
    try {
      if (editing) { await api.put(`/admin/seo/${editing}`, form); }
      else { await api.post('/admin/seo', form); }
      resetForm(); load();
    } catch (err) { alert(err.response?.data?.detail || 'Error'); }
  };

  const handleEdit = (p) => {
    setForm({ path: p.path, title: p.title, description: p.description || '', keywords: p.keywords || '', og_image: p.og_image || '' });
    setEditing(p.id); setShowForm(true);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Delete this SEO entry?')) return;
    await api.delete(`/admin/seo/${id}`); load();
  };

  return (
    <div className="admin-section">
      <div className="section-header">
        <h2 className="section-title"><Search size={20} /> SEO Manager ({pages.length})</h2>
        <button className="btn-primary" onClick={() => { resetForm(); setShowForm(true); }}><Plus size={16} /> Add Page SEO</button>
      </div>

      {showForm && (
        <div className="admin-card">
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
            <h3 className="card-subtitle" style={{ margin: 0 }}>{editing ? 'Edit SEO' : 'Add Page SEO'}</h3>
            <button className="btn-sm btn-delete" onClick={resetForm}><X size={14} /></button>
          </div>
          <form onSubmit={handleSave}>
            <div className="two-col">
              <div>
                <label className="form-label">Page Path *</label>
                <input className="form-input" value={form.path} onChange={e => setForm({...form, path: e.target.value})} required placeholder="/ or /category/japan" />
                <span style={{ fontSize: 10, color: '#555' }}>URL path to apply SEO (e.g. /, /pages/about)</span>
              </div>
              <div>
                <label className="form-label">SEO Title *</label>
                <input className="form-input" value={form.title} onChange={e => setForm({...form, title: e.target.value})} required placeholder="Raja Bokep - Nonton Bokep Gratis" />
              </div>
            </div>
            <div style={{ marginTop: 12 }}>
              <label className="form-label">Meta Description</label>
              <textarea className="form-textarea" value={form.description} onChange={e => setForm({...form, description: e.target.value})} rows={3} placeholder="Deskripsi halaman untuk search engine..." />
            </div>
            <div className="two-col" style={{ marginTop: 12 }}>
              <div>
                <label className="form-label">Keywords</label>
                <input className="form-input" value={form.keywords} onChange={e => setForm({...form, keywords: e.target.value})} placeholder="bokep, video bokep, nonton bokep" />
              </div>
              <div>
                <label className="form-label">OG Image URL</label>
                <input className="form-input" value={form.og_image} onChange={e => setForm({...form, og_image: e.target.value})} placeholder="https://raja-bokep.com/og-image.jpg" />
              </div>
            </div>

            {/* Google Preview */}
            <div style={{ marginTop: 16 }}>
              <label className="form-label">Google Search Preview</label>
              <div className="seo-preview">
                <p className="seo-preview-title">{form.title || 'Page Title'}</p>
                <p className="seo-preview-url">https://raja-bokep.com{form.path || '/'}</p>
                <p className="seo-preview-desc">{form.description || 'Page description will appear here in search results...'}</p>
              </div>
            </div>

            <div style={{ display: 'flex', gap: 8, marginTop: 16 }}>
              <button type="submit" className="btn-primary"><Save size={16} /> {editing ? 'Update' : 'Save SEO'}</button>
              <button type="button" className="btn-secondary" onClick={resetForm}>Cancel</button>
            </div>
          </form>
        </div>
      )}

      <div className="admin-card" style={{ padding: 0, overflow: 'hidden' }}>
        <table className="admin-table">
          <thead>
            <tr><th>Path</th><th>Title</th><th>Description</th><th>Keywords</th><th>Actions</th></tr>
          </thead>
          <tbody>
            {pages.length === 0 ? (
              <tr><td colSpan={5} style={{ textAlign: 'center', padding: 30, color: '#555' }}>No SEO pages configured yet. Add SEO for homepage, categories, etc.</td></tr>
            ) : pages.map(p => (
              <tr key={p.id}>
                <td style={{ fontWeight: 700, color: '#f59e0b' }}>{p.path}</td>
                <td style={{ fontWeight: 600, color: '#ddd' }}>{p.title}</td>
                <td style={{ maxWidth: 200, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', color: '#888', fontSize: 12 }}>{p.description || '-'}</td>
                <td style={{ maxWidth: 150, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', color: '#666', fontSize: 11 }}>{p.keywords || '-'}</td>
                <td>
                  <div style={{ display: 'flex', gap: 4 }}>
                    <button className="btn-sm btn-edit" onClick={() => handleEdit(p)}><Pencil size={12} /></button>
                    <button className="btn-sm btn-delete" onClick={() => handleDelete(p.id)}><Trash2 size={12} /></button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default SEOManager;
